import { VOID3gxj6tk5isa35 as VOID } from '../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED } from '../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/Intrinsics.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { JobSupport3fdjh0rbee4be as JobSupport } from './JobSupport.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { suspendOrReturn49pspzlx5djv as suspendOrReturn } from '../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/IntrinsicsJs.mjs';
import { CompletedExceptionally3itrk74dxkv9s as CompletedExceptionally } from './CompletionState.mjs';
import { Job29shfjfygy86k as Job } from './Job.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function CompletableDeferred(parent) {
  parent = parent === VOID ? null : parent;
  return new (CompletableDeferredImpl())(parent);
}
function *_generator_await__mos7q6($this, $completion) {
  var tmp = $this.ba4($completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp_0 = tmp;
  return (tmp_0 == null ? true : !(tmp_0 == null)) ? tmp_0 : THROW_CCE();
}
var CompletableDeferredImplClass;
function CompletableDeferredImpl() {
  if (CompletableDeferredImplClass === VOID) {
    class $ extends JobSupport() {
      constructor(parent) {
        super(true);
        this.aa2(parent);
      }
      ka3() {
        return true;
      }
      wa4() {
        var tmp = this.aa4();
        return (tmp == null ? true : !(tmp == null)) ? tmp : THROW_CCE();
      }
      ea4($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_await__mos7q6.bind(VOID, this), $completion);
      }
      na8(value) {
        return this.ta3(value);
      }
      oa8(exception) {
        return this.ta3(new (CompletedExceptionally())(exception));
      }
    }
    initMetadataForClass($, 'CompletableDeferredImpl', VOID, VOID, [JobSupport(), Job()], [0]);
    CompletableDeferredImplClass = $;
  }
  return CompletableDeferredImplClass;
}
//region block: exports
export {
  CompletableDeferred as CompletableDeferred2lnqvsbvx74d3,
};
//endregion

//# sourceMappingURL=CompletableDeferred.mjs.map
